import moment, { DurationInputArg2 } from 'moment';

const RANGE_SEPARATOR = '-to-';

export class DateFilterValue {
    from?: Date | null;
    to?: Date | null;
    relative?: `${number}_${DurationInputArg2}`;

    constructor(props: Partial<DateFilterValue>) {
        Object.assign(this as any, props);
    }

    toRange(now?: Date) {
        if (this.relative) {
            const [amount, unit] = this.relative.split('_');
            const to = moment(now || new Date());
            const from = moment(to).subtract(amount, unit as DurationInputArg2);
            return { from: from, to: to };
        }

        return { from: this.from, to: this.to };
    }

    static serialize(value?: DateFilterValue) {
        if (!value) {
            return undefined;
        }

        if (value.relative) {
            return value.relative;
        }

        if (value.from || value.to) {
            return `${toUtcDateTimeString(value.from)}${RANGE_SEPARATOR}${toUtcDateTimeString(
                value.to,
            )}`;
        }

        return undefined;
    }

    static parse(param?: string) {
        if (!param) {
            return undefined;
        }

        const parts = param.split(RANGE_SEPARATOR);
        if (parts.length === 1) {
            return new DateFilterValue({ relative: parts[0] as any });
        }
        if (parts.length === 2) {
            return new DateFilterValue({
                from: fromUtcDateTimeString(parts[0]),
                to: fromUtcDateTimeString(parts[1]),
            });
        }

        return undefined;
    }
}

(window as any).DateFilterValue = DateFilterValue;

function toUtcDateTimeString(date) {
    return date ? moment(date).utc().toISOString() : null;
}

function fromUtcDateTimeString(str: string) {
    const date = moment(str || '');

    if (date.isValid()) {
        return date.toDate();
    }
}
